import { Box, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import FirstStep from "./FirstStep";
import { Button } from 'react-bootstrap';
import SecondStep from "./SecondStep";
import ThirdStep from "./ThirdStep";
import ForthStep from "./ForthStep";
import FifthStep from "./FifthStep";
import SixthStep from "./SixthStep";
import SeventhStep from "./SeventhStep";
import EightStep from "./EightStep";
import NinthStep from "./NinthStep";
import { useSteps } from "./useSteps";
import axios from 'axios';
import useBreakpoint from "./useBreakpoint";
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import {Button as ButtonMaterial }from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import FirstStepMobile from "./mobileSteps/FirstStepMobile";
import SecondStepMobile from "./mobileSteps/SecondStepMobile";
import ThirdStepMobile from "./mobileSteps/ThirdStepMobile";
import ForthStepMobile from "./mobileSteps/ForthStepMobile";
import FifthStepMobile from "./mobileSteps/FifthStepMobile";
import SixthStepMobile from "./mobileSteps/SixthStepMobile";
import SeventhStepMobile from "./mobileSteps/SeventhStepMobile";
import EightStepMobile from "./mobileSteps/EightStepMobile";
import NinthStepMobile from "./mobileSteps/NinthStepMobile";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const steps = [
    '',
    '',
    '', "", "", "", "", "", ""
  ];

const NewEvaluation = () => {
  const {
    firstStep,
    secondStep,
    thirdStep,
    forthStep,
    fifthStep,
    sixthStep,
    sevenStep,
    eightStep,
    nineStep,
    type,
    evaluation_id,
    submission_id,
    la_id,
    user_id,
    updateMultipleValues
  } = useSteps();

  const [size] = useBreakpoint();
  const location = useLocation();
  const navigate = useNavigate();


// get userId
  let row = location?.state?.row;
  let rowOLA = location?.state?.rowOLA;

  console.log(row, rowOLA);

  const [user, setUser] = useState({});

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    axios.get("http://ascola-dev01.it.auth.gr/api/users", {
            params: {
                email: tokenEmail(token)
            }, headers: { Authorization: "Bearer " + token} })
        .then((response) => {
        console.log(response); setUser(response.data);
        });
    }, []);

  useEffect(() => {
		if (row) {
      updateMultipleValues({firstStep: {age: row.evaluation_submission.age, gender: row.evaluation_submission.gender, 
        host_schac: row.evaluation_submission.host_schac, home_schac: row.evaluation_submission.home_schac, course_title: row.course.course_title, gender_other: "string", study_field: row.evaluation_submission.study_field},
      secondStep: {course_quality: row.evaluation.course_quality, course_organisation: row.evaluation.course_organisation, 
        course_prerequisites: row.evaluation.course_prerequisites, course_clear_objectives: row.evaluation.course_clear_objectives,
        course_topic_relevance: row.evaluation.course_topic_relevance, course_online_tools: row.evaluation.course_online_tools
      }, thirdStep: {course_relevant_lectures : row.evaluation.course_relevant_lectures, course_motivational_activities: row.evaluation.course_motivational_activities,
        course_future_employment: row.evaluation.course_future_employment, course_societal_reflexion: row.evaluation.course_societal_reflexion,
        course_materials: row.evaluation.course_materials, course_social_interaction: row.evaluation.course_social_interaction,
        course_study_load: row.evaluation.course_study_load}, forthStep: {teacher_approachability: row.evaluation.teacher_approachability, teacher_contact_moments :
          row.evaluation.teacher_contact_moments, teacher_discussion_opportunities: row.evaluation.teacher_discussion_opportunities,
          teacher_specific_needs: row.evaluation.teacher_specific_needs, teacher_motivating_manner: row.evaluation.teacher_motivating_manner,
          teacher_international_perspective: row.evaluation.teacher_international_perspective}, fifthStep: {cultural_international_perspective: 
            row.evaluation.cultural_international_perspective, cultural_thought_sharing: row.evaluation.cultural_thought_sharing,
            cultural_student_contact: row.evaluation.cultural_student_contact, cultural_prejudice: row.evaluation.cultural_prejudice,
            cultural_language_barriers: row.evaluation.cultural_language_barriers, cultural_differences_experiences : row.evaluation.cultural_differences_experiences}, sixthStep: {methods_details_communication: row.evaluation.methods_details_communication,
              methods_communication_correspondence: row.evaluation.methods_communication_correspondence, methods_subject_consistency: row.evaluation.methods_subject_consistency,
              methods_cultural_attention: row.evaluation.methods_cultural_attention, methods_learning_satisfaction: row.evaluation.methods_learning_satisfaction},
            sevenStep: {evaluation_sufficiency: row.evaluation.evaluation_sufficiency, evaluation_sharing_opportunities: row.evaluation.evaluation_sharing_opportunities,
              evaluation_timing: row.evaluation.evaluation_timing}, eightStep: {general_participation_motives : row.evaluation.general_participation_motives,
                general_satisfaction_aspects: row.evaluation.general_satisfaction_aspects, general_likes_dislikes: row.evaluation.general_likes_dislikes,
                general_would_recommend: row.evaluation.general_would_recommend, general_recommendation_explanation: row.evaluation.general_recommendation_explanation,
                general_participation_motives_other: row.evaluation.general_participation_motives_other, general_satisfaction_aspects_other: row.evaluation.general_satisfaction_aspects_other, general_would_recommend_other: "string"},
              nineStep: {general_thoughts: row.evaluation.general_thoughts}, type: "edit", evaluation_id: row.evaluation.evaluation_id, submission_id: row.evaluation.submission_id,
            la_id: row.evaluation_submission.la_id, user_id: row.evaluation_submission.user_id});
    }
    if(rowOLA) {
      updateMultipleValues({firstStep: {host_schac: rowOLA.institution_schac, home_schac: rowOLA.home_institution_schac, course_title: rowOLA.course_title, course_code: rowOLA.course_code,
        gender_other: "string", study_field: rowOLA.study_field, academic_term: rowOLA.academic_term, ects: rowOLA.ects},
      la_id: rowOLA.la_id, type: "add"})
    }
	}, [row, rowOLA]);

  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  

  const tokenEmail = (token) => {
    if (!token) return true;
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken.email;
    } catch (error) {
      console.error('Error decoding token:', error);
      return true;
    }
  };

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleSubmitAdd = () => {
    console.log({...secondStep, ...thirdStep});

    axios.post("http://ascola-dev01.it.auth.gr/api/evaluations", {
      course: {academic_term: firstStep.academic_term, course_code: firstStep.course_code, course_title: firstStep.course_title, ects: firstStep.ects, 
        institution_schac: firstStep.host_schac},
      evaluation: {...secondStep, ...thirdStep, ...forthStep, ...fifthStep, ...sixthStep, ...sevenStep, ...eightStep, ...nineStep},
      evaluation_submission: {la_id: la_id, user_id: user?.user_id, home_schac: firstStep.home_schac, host_schac: firstStep.host_schac, gender: firstStep.gender, 
        gender_other: firstStep.gender_other, age: firstStep.age}
      // user_id: "65331abc-56fb-436e-8401-f8ce89644b0b", ...firstStep, ...secondStep, ...thirdStep, ...forthStep, ...fifthStep, ...sixthStep, ...sevenStep, ...eightStep, ...nineStep,
      // home_schac: "string", host_schac: "string", institution_schac: "string", la_id: "4b7f245c-7c92-48ec-8c84-c489ece4289f", academic_term: "string", course_title: "string", course_code: "string"
      },{ headers: { Authorization: "Bearer " + localStorage.getItem('access_token')}})
    .then((response) => {
      console.log(response); alert("Successfully Submitted!"); navigate("/my-evaluations");
    });
  };

  const handleSubmitEdit = () => {
    console.log({...secondStep, ...thirdStep});

    axios.patch("http://ascola-dev01.it.auth.gr/api/evaluations/" + evaluation_id + "/" + submission_id, {
      evaluation: {...secondStep, ...thirdStep, ...forthStep, ...fifthStep, ...sixthStep, ...sevenStep, ...eightStep, ...nineStep},
      evaluation_submission: {la_id: la_id, user_id: user_id, home_schac: firstStep.home_schac, host_schac: firstStep.host_schac, gender: firstStep.gender, 
        gender_other: firstStep.gender_other, age: firstStep.age}
      },{ headers: { Authorization: "Bearer " + localStorage.getItem('access_token')}})
    .then((response) => {
      console.log(response); alert("Successfully Submitted!"); navigate("/my-evaluations");
    });
  };

  return (<>
    {(size !== "xs" && size !== "sm" && size !== "md") && ( <> 
      <Box sx={{ width: '100%' , marginTop: 4}}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          // if (isStepOptional(index)) {
          //   labelProps.optional = (
          //     <Typography variant="caption">Optional</Typography>
          //   );
          // }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} sx={{
                '& .MuiStepLabel-root .Mui-completed': {
                  color: 'white', // circle color (COMPLETED)
                },
                '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel':
                  {
                    color: 'grey.500', // Just text label (COMPLETED)
                  },
                '& .MuiStepLabel-root .Mui-active': {
                  color: 'white', borderColor: "black", borderWidth: 2// circle color (ACTIVE)
                },
                '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel':
                  {
                    color: 'white', // Just text label (ACTIVE)
                  },
                '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                  fill: 'black', // circle's number (ACTIVE)
                },
                '& .MuiStepLabel-root .Mui-active .MuiStepIcon-root': {
                    borderColor: "black", borderWidth: 2, // circle's number (ACTIVE)
                }
              }} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === 0 && (
        <>
          <FirstStep firstStep={firstStep} updateMultipleValues={updateMultipleValues}/>
          <Box sx={{  mt: 10, mb: 1}}>
            <Box sx={{  mt: 2, mb: 1}}/>
            <Button style={{borderRadius: 0, marginBottom: 150}} className='normal-button' onClick={handleNext} disabled={!firstStep?.gender || !firstStep?.age}>Next Step</Button>
          </Box>
        </>
      )}
      {activeStep === 1 && (
        <>
          <SecondStep secondStep={secondStep} updateMultipleValues={updateMultipleValues}/>
          <Box sx={{  mt: 10, mb: 1}}>
            <Box sx={{  mt: 2, mb: 1}}/>
            <Button style={{borderRadius: 0, marginBottom: 150, marginRight: 20}} className='normal-button' onClick={handleBack}>Previous</Button>
            <Button style={{borderRadius: 0, marginBottom: 150}} className='normal-button' onClick={handleNext} disabled={!secondStep?.course_quality 
              || !secondStep?.course_organisation || !secondStep?.course_prerequisites || !secondStep?.course_clear_objectives || !secondStep?.course_topic_relevance || 
              !secondStep?.course_online_tools}>Next Step</Button>
          </Box>
        </>
      )}
      {activeStep === 2 && (
        <>
          <ThirdStep updateMultipleValues={updateMultipleValues} thirdStep={thirdStep}/>
          <Box sx={{  mt: 10, mb: 1}}>
            <Box sx={{  mt: 2, mb: 1}}/>
            <Button style={{borderRadius: 0, marginBottom: 150, marginRight: 20}} className='normal-button' onClick={handleBack}>Previous</Button>
            <Button style={{borderRadius: 0, marginBottom: 150}} className='normal-button' onClick={handleNext} disabled={!thirdStep?.course_relevant_lectures 
              || !thirdStep?.course_motivational_activities || !thirdStep?.course_future_employment || !thirdStep?.course_societal_reflexion || !thirdStep?.course_materials || 
              !thirdStep?.course_social_interaction || !thirdStep?.course_study_load}>Next Step</Button>
          </Box>
        </>
      )}
      {activeStep === 3 && (
        <>
          <ForthStep forthStep={forthStep} updateMultipleValues={updateMultipleValues}/>
          <Box sx={{  mt: 10, mb: 1}}>
            <Box sx={{  mt: 2, mb: 1}}/>
            <Button style={{borderRadius: 0, marginBottom: 150, marginRight: 20}} className='normal-button' onClick={handleBack}>Previous</Button>
            <Button style={{borderRadius: 0, marginBottom: 150}} className='normal-button' onClick={handleNext} disabled={!forthStep?.teacher_approachability 
              || !forthStep?.teacher_contact_moments || !forthStep?.teacher_discussion_opportunities || !forthStep?.teacher_specific_needs || !forthStep?.teacher_motivating_manner || 
              !forthStep?.teacher_international_perspective}>Next Step</Button>
          </Box>
        </>
      )}
      {activeStep === 4 && (
        <>
          <FifthStep fifthStep={fifthStep} updateMultipleValues={updateMultipleValues}/>
          <Box sx={{  mt: 10, mb: 1}}>
            <Box sx={{  mt: 2, mb: 1}}/>
            <Button style={{borderRadius: 0, marginBottom: 150, marginRight: 20}} className='normal-button' onClick={handleBack}>Previous</Button>
            <Button style={{borderRadius: 0, marginBottom: 150}} className='normal-button' onClick={handleNext} disabled={!fifthStep?.cultural_international_perspective 
              || !fifthStep?.cultural_thought_sharing || !fifthStep?.cultural_student_contact || !fifthStep?.cultural_prejudice || !fifthStep?.cultural_language_barriers}>Next Step</Button>
          </Box>
        </>
      )}
      {activeStep === 5 && (
        <>
          <SixthStep sixthStep={sixthStep} updateMultipleValues={updateMultipleValues}/>
          <Box sx={{  mt: 10, mb: 1}}>
            <Box sx={{  mt: 2, mb: 1}}/>
            <Button style={{borderRadius: 0, marginBottom: 150, marginRight: 20}} className='normal-button' onClick={handleBack}>Previous</Button>
            <Button style={{borderRadius: 0, marginBottom: 150}} className='normal-button' onClick={handleNext} disabled={!sixthStep?.methods_details_communication 
              || !sixthStep?.methods_communication_correspondence || !sixthStep?.methods_subject_consistency || !sixthStep?.methods_cultural_attention || !sixthStep?.methods_learning_satisfaction}>Next Step</Button>
          </Box>
        </>
      )}
      {activeStep === 6 && (
        <>
          <SeventhStep sevenStep={sevenStep} updateMultipleValues={updateMultipleValues}/>
          <Box sx={{  mt: 10, mb: 1}}>
            <Box sx={{  mt: 2, mb: 1}}/>
            <Button style={{borderRadius: 0, marginBottom: 150, marginRight: 20}} className='normal-button' onClick={handleBack}>Previous</Button>
            <Button style={{borderRadius: 0, marginBottom: 150}} className='normal-button' onClick={handleNext} disabled={!sevenStep?.evaluation_sufficiency 
              || !sevenStep?.evaluation_sharing_opportunities || !sevenStep?.evaluation_timing}>Next Step</Button>
          </Box>
        </>
      )}
      {activeStep === 7 && (
        <>
          <EightStep eightStep={eightStep} updateMultipleValues={updateMultipleValues}/>
          <Box sx={{  mt: 10, mb: 1}}>
            <Box sx={{  mt: 2, mb: 1}}/>
            <Button style={{borderRadius: 0, marginBottom: 150, marginRight: 20}} className='normal-button' onClick={handleBack}>Previous</Button>
            <Button style={{borderRadius: 0, marginBottom: 150}} className='normal-button' onClick={handleNext} disabled={!eightStep?.general_participation_motives 
              || !eightStep?.general_satisfaction_aspects || !eightStep?.general_would_recommend || !eightStep?.general_recommendation_explanation}>Next Step</Button>
          </Box>
        </>
      )}
      {activeStep === 8 && (
        <>
          <NinthStep nineStep={nineStep} updateMultipleValues={updateMultipleValues}/>
          <Box sx={{  mt: 10, mb: 1}}>
            <Box sx={{  mt: 2, mb: 1}}/>
            <Button style={{borderRadius: 0, marginBottom: 150, marginRight: 20}} className='normal-button' onClick={handleBack}>Previous</Button>
            <Button style={{borderRadius: 0, marginBottom: 150}} className='normal-button' onClick={() => type === "add" ? handleSubmitAdd() : handleSubmitEdit()}
            // disabled={!nineStep?.general_thoughts}
            disabled
            >Submit</Button>
          </Box>
        </>
      )}
    </Box>
    </>
  )}
  {(size === "xs" || size === "sm" || size === "md") && ( <>
    <Box sx={{ width: '100vw', flexGrow: 1 }}>
    {activeStep === 0 && (
        <>
          <FirstStepMobile firstStep={firstStep} updateMultipleValues={updateMultipleValues}/>
        </>
      )}
      {activeStep === 1 && (
        <>
          <SecondStepMobile secondStep={secondStep} updateMultipleValues={updateMultipleValues}/>
        </>
      )}
      {activeStep === 2 && (
        <>
          <ThirdStepMobile updateMultipleValues={updateMultipleValues} thirdStep={thirdStep}/>
        </>
      )}
      {activeStep === 3 && (
        <>
          <ForthStepMobile forthStep={forthStep} updateMultipleValues={updateMultipleValues}/>
        </>
      )}
      {activeStep === 4 && (
        <>
          <FifthStepMobile fifthStep={fifthStep} updateMultipleValues={updateMultipleValues}/>
        </>
      )}
      {activeStep === 5 && (
        <>
          <SixthStepMobile sixthStep={sixthStep} updateMultipleValues={updateMultipleValues}/>
        </>
      )}
      {activeStep === 6 && (
        <>
          <SeventhStepMobile sevenStep={sevenStep} updateMultipleValues={updateMultipleValues}/>
        </>
      )}
      {activeStep === 7 && (
        <>
          <EightStepMobile eightStep={eightStep} updateMultipleValues={updateMultipleValues}/>
        </>
      )}
      {activeStep === 8 && (
        <>
          <NinthStepMobile nineStep={nineStep} updateMultipleValues={updateMultipleValues}/>
          <Box sx={{  mt: 10, mb: 1}}>
            <Box sx={{  mt: 2, mb: 1}}/>
            <Button style={{borderRadius: 0, marginBottom: 50}} className='normal-button' onClick={() => type === "add" ? handleSubmitAdd() : handleSubmitEdit()} disabled>Submit</Button>
          </Box>
        </>
      )}
      <MobileStepper
        style={{width: "100vw"}}
        variant="text"
        steps={9}
        position="static"
        activeStep={activeStep}
        nextButton={
          <ButtonMaterial
            size="small"
            onClick={handleNext}
            disabled={activeStep === 8}
          >
            Next
            
              <KeyboardArrowRight />
            
          </ButtonMaterial>
        }
        backButton={
          <ButtonMaterial size="small" onClick={handleBack} disabled={activeStep === 0}>
            
              <KeyboardArrowLeft />
            
            Back
          </ButtonMaterial>
        }
      />
    </Box>
  </> )}
  </>
  );
  };
  
  export default NewEvaluation;
  